<template>
  <v-card class="mx-auto my-10 text-center" max-width="500" elevation="2">
    <v-card-text class="py-10">
      <v-icon size="64" color="#17408B">mdi-hammer-wrench</v-icon>
      <p class="text-h5 text--primary mt-4">Prop Finder is coming soon</p>
      <p class="body-1 mb-0">
        We're rebuilding this tool. Check back shortly.
      </p>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "Nflpropfinder",
};
</script>
